import {get} from './http'


// 生成树图
export const getNetworkTree = params => get('/network/tree',params)

// 树图节点搜索
export const getNetworkSearch = params => get('/network/search',params)





// 材料list
export const getBiomaterialList= params => get('/statistics/getBiomaterial',params)

//cells
export const getCellList= params => get('/statistics/cellList',params)

//modification
export const getModificationList= params => get('/statistics/modificationList',params)

// manufacturing method
export const getManufacturingMethodList = params => get('/statistics/manufacturingMethodList',params)

//crosslinker
export const getCrosslinkerList= params => get('/statistics/crosslinkerList',params)

//institute
export const getInstituteList= params => get('/statistics/instituteList',params)

//author
export const getAuthorList= params => get('/statistics/authorList',params)

//country
export const getCountryList= params => get('/statistics/country',params)

//Journal
export const getJournalList= params => get('/statistics/journalList',params)

//organ/structure
export const getOrganStructureList= params => get('/statistics/organStructureList',params)

//Paper
export const getRelatedPaper= params => get('/statistics/relatedPaper',params)





//claims
export const getPatentClaims= params => get('/Patent/claims',params)
//country
export const getPatentCountry= params => get('/Patent/country',params)
//grants
export const getPatentGrants= params => get('/Patent/grants',params)
//instituteList
export const getPatentInstituteList= params => get('/Patent/instituteList',params)
//patents
export const getRelatedPatent= params => get('/Patent/relatedPatent',params)





//biomaterial
export const getPatentBiomaterial= params => get('/Patent/biomaterial',params)
//cell
export const getPatentCell= params => get('/Patent/cell',params)
//organ
export const getPatentOrgan= params => get('/Patent/organ',params)







// WEBPACK FOOTER //
// ./src/request/materials.js